import { Injectable } from "@angular/core";
import { AlertController } from "@ionic/angular";
import { TranslocoService } from "@ngneat/transloco";
import { RideOpsUiService } from "./rideops-ui.service";

@Injectable({ providedIn: "root" })
export class AlertService {
	constructor(
		private alertController: AlertController,
		private translocoService: TranslocoService,
		private rideOpsUi: RideOpsUiService,
	) {}

	private v2DialogCssClass = (): string | undefined =>
		this.rideOpsUi.isV2Active() ? "operators-v2-dialog" : undefined;

	showWarningNotClearedForOperation = async () => {
		const notReadyAlert = await this.alertController.create({
			header: this.translocoService.translate("NOT_READY_WARNING_ON_OPEN_ALERT__TITLE"),
			message: this.translocoService.translate("NOT_READY_WARNING_ON_OPEN_ALERT__MESSAGE"),
			cssClass: this.v2DialogCssClass(),
			buttons: [
				{
					text: this.translocoService.translate("NOT_READY_WARNING_ON_OPEN_ALERT__CANCEL"),
					role: "cancel",
				},
			],
		});

		await notReadyAlert.present();
	};

	alertNoLongerClearedForOperation = async () => {
		const alert = await this.alertController.create({
			header: this.translocoService.translate("LOCATION_NOT_READY_FOR_OPERATION_ALERT__TITLE"),
			message: this.translocoService.translate("LOCATION_NOT_READY_FOR_OPERATION_ALERT__MESSAGE"),
			backdropDismiss: false,
			cssClass: this.v2DialogCssClass(),
			buttons: [this.translocoService.translate("LOCATION_NOT_READY_FOR_OPERATION_ALERT__OK")],
		});

		await alert.present();
	};

	alertLocationNoLongerOpen = async () => {
		const alert = await this.alertController.create({
			header: this.translocoService.translate("LOCATION_IS_NOT_OPEN_ALERT__TITLE"),
			message: this.translocoService.translate("LOCATION_IS_NOT_OPEN_ALERT__MESSAGE"),
			backdropDismiss: false,
			cssClass: this.v2DialogCssClass(),
			buttons: [this.translocoService.translate("LOCATION_IS_NOT_OPEN_ALERT__OK")],
		});

		await alert.present();
	};

	showErrorWhileClosingLocationAlert = async () => {
		const alert = await this.alertController.create({
			message: this.translocoService.translate("CLOSE_LOCATION__ERROR_MESSAGE"),
			buttons: [this.translocoService.translate("CLOSE_LOCATION__OK")],
			backdropDismiss: true,
			cssClass: this.v2DialogCssClass(),
		});

		await alert.present();
	};

	showErrorWhileOpeningLocationAlert = async () => {
		const alert = await this.alertController.create({
			message: this.translocoService.translate("OPEN_LOCATION_ERROR_MESSAGE"),
			buttons: [this.translocoService.translate("OPERATOR_LOGIN__OK")],
			backdropDismiss: true,
			cssClass: this.v2DialogCssClass(),
		});

		await alert.present();
	};

	showErrorWhileResolvingDowntimeAlert = async () => {
		const alert = await this.alertController.create({
			message: this.translocoService.translate("RESOLVE_DOWNTIME__ERROR_MESSAGE"),
			buttons: [this.translocoService.translate("OPERATOR_LOGIN__OK")],
			backdropDismiss: true,
			cssClass: this.v2DialogCssClass(),
		});

		await alert.present();
	};
}
